import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageIntro from '../components/PageIntro';

const About: React.FC = () => {
  useEffect(() => { document.title = 'About — Haven Crest Health'; }, []);
  return (
    <main>
      <PageIntro
        eyebrow="About"
        title={<>Your records belong to you. Getting them <em>shouldn't be a project.</em></>}
        lede="You have the right to a copy of your own medical records. In practice that means finding the right fax number, filling out a form, calling to check, calling again, and waiting. Haven Crest turns all of that into one click, for free."
      />
      <section className="section">
        <div className="wrap grid grid--2">
          <div className="card">
            <h3>What Haven Crest is</h3>
            <ul>
              <li>Free patient advocacy and care coordination, with a navigator who knows your file</li>
              <li>Your own health inbox, where requesting records from any provider is one click, sent on your behalf</li>
              <li>People who follow up with offices, explain what comes back, and help you find doctors</li>
              <li>Voluntary: you choose what to request, and you can leave anytime</li>
            </ul>
          </div>
          <div className="card">
            <h3>What it isn't</h3>
            <ul>
              <li>Not a doctor's office. We don't diagnose, treat, or give medical advice.</li>
              <li>Not a subscription. There's nothing to pay us.</li>
              <li>Not a way around provider fees. If a provider bills for your records, you're responsible for that fee, and we tell you first.</li>
              <li>Not a replacement for your clinicians. Decisions about your care stay between you and them.</li>
            </ul>
          </div>
        </div>
        <div className="wrap center" style={{ marginTop: '3rem' }}>
          <Link to="/contact" className="btn btn--ink">Get an advocate, free <span className="arrow">→</span></Link>
        </div>
      </section>
    </main>
  );
};

export default About;
